<template>
  <v-dialog v-model="openDialog" max-width="650" persistent>
    <template #activator="{ on, attrs }">
      <div v-bind="attrs" class="display-inline" v-on="on">
        <slot />
      </div>
    </template>

    <v-card>
      <v-toolbar color="indigo" dark>
        <v-toolbar-title
          >Telefon Numarası
          {{ currentLead.user.phone ? "Güncelle" : "Ekle" }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="close" icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-form ref="form" v-model="isFormValid">
        <v-card-text>
          <SMPhoneSelectbox
            validatable
            :phone="phone"
            :validate-id="currentLead.user.id"
            :check-user-phone="phone"
            @update:phone="updatePhone"
          ></SMPhoneSelectbox>
        </v-card-text>
        <v-card-actions class="d-flex justify-content-end">
          <v-btn color="error" class="mr-2" @click="close">İptal</v-btn>
          <v-btn color="primary" :disabled="!isFormValid" @click="savePhone">
            Kaydet
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import SMPhoneSelectbox from "../../content/siliconmade/SM-Phone-Selectbox.vue";

export default {
  name: "EditUserPhoneModal",
  components: {
    SMPhoneSelectbox,
  },
  props: {
    currentLead: Object,
  },
  data() {
    return {
      openDialog: false,
      phone: this.currentLead.user.phone || "",
      isFormValid: true,
    };
  },
  watch: {
    openDialog(val) {
      if (val) {
        if (this.currentLead.user.phone === this.phone) {
          this.$nextTick(() => {
            this.isFormValid = false;
          });
        }
      }
    },
  },
  methods: {
    close() {
      this.openDialog = false;
    },
    updatePhone(phone) {
      this.phone = phone;
    },
    async savePhone() {
      const valid = this.$refs.form.validate();
      if (!valid) {
        this.isFormValid = false;
        return;
      }

      try {
        const user = await this.postUserPhone();
        const updatedLead = {
          ...this.currentLead,
          user: {
            ...this.currentLead.user,
            phone: user.phone,
          },
        };
        this.$store.commit("setLead", updatedLead);
        this.$toast.success("Kullanıcı başarıyla güncellendi.", {
          duration: 2000,
          position: "bottom-right",
        });
        this.close();
      } catch (error) {
        this.$toast.error(error[0].detail, {
          position: "bottom-right",
          duration: 2000,
        });
      }
    },
    postUserPhone() {
      return new Promise((resolve, reject) => {
        this.$apiService
          .put(`/users/${this.currentLead.user.id}/update-phone`, {
            phone: this.phone,
          })
          .then(({ data }) => {
            resolve(data);
          })
          .catch(({ response }) => {
            reject(response.data.errors);
          });
      });
    },
  },
};
</script>
